import classNames from "classnames"
import { LabelProps } from "../../types/LabelProps"

export interface Props extends LabelProps {
  className?: string
}

export function FormHelperText({ children, className, ...rest }: Props) {
  return (
    <label
      className={classNames(
        "[font-family:var(--alias-font-body-sm-base-font-family)] [font-size:var(--alias-font-body-sm-base-font-size)] text-[color:var(--alias-color-text-weaker)] pt-[var(--alias-padding-xxxs)]",
        className,
      )}
      {...rest}
    >
      {children}
    </label>
  )
}
